import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Button,
  IconButton,
  Checkbox,
  FormControlLabel,
  Paper
} from "@mui/material";
import { BiTrash } from "react-icons/bi";

//  Contacts section formatted as a Table to match ContactsCard component style
const PublicContactsSection = ({ contacts, onContactsChange, title, isAr }) => {

  const addContact = () => {
    // Adding new contact with all 8 fields (including SignedUp)
    onContactsChange([
      ...contacts,
      {
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: "",
        CanPickUp: false,
        SignedUp: false, 
        ContactType: "",
        ContactStatus: "",
      },
    ]);
  };

  const removeContact = (index) => {
    onContactsChange(contacts.filter((_, i) => i !== index));
  };

  const updateContact = (index, key, value) => {
    const updated = contacts.map((c, i) =>
      i === index ? { ...c, [key]: value } : c
    );
    onContactsChange(updated);
  };

  // Table headers based on the fields
  const headers = [
    isAr ? "الاسم الأول" : "First Name",
    isAr ? "اسم العائلة" : "Last Name",
    isAr ? "البريد الإلكتروني" : "Email",
    isAr ? "الهاتف" : "Phone",
    isAr ? "يمكنه الاستلام" : "Can Pick Up",
    isAr ? "مسجَل" : "Signed Up",
    isAr ? "الصلة" : "Type",
    isAr ? "الحالة" : "Status",
    "" // For delete action
  ];

  return (
    <Box className="info-card mb-4 shadow-sm" sx={{ border: "1px solid #e0e0e0", borderRadius: 2, overflow: "hidden", bgcolor: "white" }}>
      <Box sx={{ p: 2, bgcolor: "#f8f9fa", borderBottom: "1px solid #e0e0e0" }}>
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#333" }}>{title}</Typography>
      </Box>

      <Box sx={{ overflowX: "auto" }}>
        <Table size="small">
          <TableHead sx={{ bgcolor: "#f2f2f2" }}>
            <TableRow>
              {headers.map((head, i) => (
                <TableCell key={i} align={isAr ? "right" : "left"} sx={{ fontWeight: "bold", py: 1.5 }}>
                  {head}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {contacts.map((contact, index) => (
              <TableRow key={index} hover>
                {/* FirstName - Required */}
                <TableCell>
                  <TextField
                    variant="standard"
                    size="small"
                    value={contact.FirstName}
                    required
                    onChange={(e) => updateContact(index, "FirstName", e.target.value)}
                  />
                </TableCell>

                {/* LastName */}
                <TableCell>
                  <TextField
                    variant="standard"
                    size="small"
                    value={contact.LastName}
                    onChange={(e) => updateContact(index, "LastName", e.target.value)}
                  />
                </TableCell>

                {/* Email */}
                <TableCell>
                  <TextField
                    variant="standard"
                    size="small"
                    type="email"
                    value={contact.Email}
                    onChange={(e) => updateContact(index, "Email", e.target.value)}
                  />
                </TableCell>

                {/* Phone */}
                <TableCell>
                  <TextField
                    variant="standard"
                    size="small"
                    value={contact.Phone}
                    onChange={(e) => updateContact(index, "Phone", e.target.value)}
                  />
                </TableCell>

                {/* CanPickUp Checkbox */}
                <TableCell align="center">
                  <Checkbox
                    checked={contact.CanPickUp}
                    onChange={(e) => updateContact(index, "CanPickUp", e.target.checked)}
                  />
                </TableCell>

                {/* SignedUp Checkbox */}
                <TableCell align="center">
                  <Checkbox
                    checked={contact.SignedUp}
                    onChange={(e) => updateContact(index, "SignedUp", e.target.checked)}
                  />
                </TableCell>

                {/* ContactType */}
                <TableCell>
                  <TextField
                    variant="standard"
                    size="small"
                    value={contact.ContactType}
                    onChange={(e) => updateContact(index, "ContactType", e.target.value)}
                  />
                </TableCell>

                {/* ContactStatus */}
                <TableCell>
                  <TextField
                    variant="standard"
                    size="small"
                    value={contact.ContactStatus}
                    onChange={(e) => updateContact(index, "ContactStatus", e.target.value)}
                  />
                </TableCell>

                {/* Actions */}
                <TableCell>
                  <IconButton color="error" onClick={() => removeContact(index)} size="small">
                    <BiTrash />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>

      <Box sx={{ p: 2 }}>
        <Button
          onClick={addContact}
          sx={{
            color: "#702E8F",
            fontWeight: 600,
            textTransform: "none",
          }}
        >
          + {isAr ? "إضافة جهة اتصال" : "Add Contact"}
        </Button>
      </Box>
    </Box>
  );
};

export default PublicContactsSection;